var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 14 14",
    role: "img",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 1.23379,9.0821203 C 1.01494,8.9761203 1,8.8432203 1,7.0019203 c 0,-1.8649 0.0133,-1.9758 0.2495,-2.0834 0.18499,-0.084 11.31601,-0.084 11.501,0 0.23622,0.1076 0.2495,0.2185 0.2495,2.0834 0,1.8648 -0.0133,1.9757 -0.2495,2.0833 -0.17686,0.081 -11.35009,0.077 -11.51671,0 z m 10.90907,-2.0802 0,-1.2858 -5.14286,0 -5.14286,0 0,1.2858 0,1.2857 5.14286,0 5.14286,0 0,-1.2857 z m -9.85715,0 0,-0.8572 0.64286,0 0.64286,0 0,0.8572 0,0.8571 -0.64286,0 -0.64286,0 0,-0.8571 z m 1.71429,0 0,-0.8572 0.64286,0 0.64285,0 0,0.8572 0,0.8571 -0.64285,0 -0.64286,0 0,-0.8571 z m 1.71429,0 0,-0.8572 0.64285,0 0.64286,0 0,0.8572 0,0.8571 -0.64286,0 -0.64285,0 0,-0.8571 z m 1.71428,0 0,-0.8572 0.64286,0 0.64286,0 0,0.8572 0,0.8571 -0.64286,0 -0.64286,0 0,-0.8571 z",
    fill: "#00A094"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.06e559d4370d46f1caabdc546c20b499.svg";
export { ForwardRef as ReactComponent };